<div class="vehicle-container" [ngClass]="{'new-vehicle' : !vehicle}">
    <div *ngIf="vehicle">
        <div class="vehicle-plate" *ngIf="vehicle"><span class="blue-plate">E</span>{{vehicle.vehiclePlate}}</div>
    </div>
    <div class="row vehicle-images" *ngIf="vehicle">
        <div class="col-12">
            <img [src]="'data:image/svg+xml;base64,'+vehicle.iconCategory" *ngIf="vehicle && vehicle.iconCategory" alt="icon" class="svg-icon" />
            <i class="bi {{iconClass}} vehicle-icon" *ngIf="vehicle && !vehicle.iconCategory"></i>
        </div>
    </div>
    <div class="vehicle-summary mb-3" *ngIf="vehicle">
        <span class="vehicle-alias">{{vehicle.vehicleAlias}}</span>
        <img [src]="'data:image/svg+xml;base64,'+vehicle.iconLabel" *ngIf="vehicle.iconLabel" alt="icon" class="svg-icon-label" />
    </div>

    <div class="pending mr-3" *ngIf="vehicle && showPending">
        <i *ngIf="vehicle.exceptionState && vehicle.exceptionState == ExceptionState.Pending" class="bi bi-circle-fill small circle-state orange"></i>
        <i *ngIf="vehicle.exceptionState && vehicle.exceptionState == ExceptionState.Attention" class="bi bi-exclamation-triangle-fill small circle-state orange"></i>
        <i *ngIf="vehicle.exceptionState && vehicle.exceptionState == ExceptionState.Revision || vehicle.exceptionState == ExceptionState.RevisionN2 || vehicle.exceptionState == ExceptionState.PreAccepted || vehicle.exceptionState == ExceptionState.PreRejected" class="bi bi-circle-fill small circle-state blue"></i>
        <i *ngIf="vehicle.exceptionState && vehicle.exceptionState == ExceptionState.Accepted" class="bi bi-circle-fill small circle-state green"></i>
        <i *ngIf="vehicle.exceptionState && vehicle.exceptionState == ExceptionState.Rejected" class="bi bi-circle-fill small circle-state red"></i>
        <i *ngIf="vehicle.exceptionState && vehicle.exceptionState == ExceptionState.Expired" class="bi bi-circle-fill small circle-state black"></i>
    </div>
    
    <i class="bi bi-plus vehicle-icon" *ngIf="!vehicle"></i>
    <p *ngIf="!vehicle" i18n>Añade un vehiculo</p>
</div>